$('.gallery-filter-title').click(function(){
    var tab_id = $(this).attr('data-tab');

    $('.gallery-filter-title').removeClass('current');
    $('.gallery-filter').removeClass('current');

    $(this).addClass('current');
    $("#"+tab_id).addClass('current');
});
